import { Language, QrStatus } from '../../../enums/const-enums';

export interface RassQrTranslations {
  errors: {
    timeout: AppModel.TimeoutTranslation;
    continue: string;
  };
  notifications: {
    [QrStatus.BLOCKED]: {
      text: string;
      type: string;
    };
    [QrStatus.CANCELED]: {
      text: string;
      type: string;
    };
    [QrStatus.REJECTED]: {
      text: string;
      type: string;
    };
  };
  instructions: Record<QrStatus, string>;
  QR_HIGH_RISK_SIGNING: string;
}

const nlTranslations: RassQrTranslations = {
  errors: {
    timeout: {
      text: 'Fout bij het bereiken van de server, probeer opnieuw!',
      type: 'warning',
    },
    continue: 'Doorgaan',
  },
  notifications: {
    [QrStatus.BLOCKED]: {
      text: 'QR-code is niet (meer) geldig of is gebruikt op een ander toestel.',
      type: 'error',
    },
    [QrStatus.CANCELED]: {
      text: 'Je hebt je QR-code geannuleerd.',
      type: 'info',
    },
    [QrStatus.REJECTED]: {
      text: 'Bevestigen via QR is niet mogelijk.',
      type: 'error',
    },
  },
  instructions: {
    [QrStatus.BLOCKED]:
      'Klik op de afbeelding om een nieuwe QR-code te genereren',
    [QrStatus.CANCELED]:
      'Klik op de afbeelding om een nieuwe QR-code te genereren',
    [QrStatus.ERROR]: 'Kies een andere methode om te bevestigen',
    [QrStatus.ISSUED]: 'Scan de QR-code met de Rabo App',
    [QrStatus.REJECTED]: 'Kies een andere methode om te bevestigen',
    [QrStatus.CONFIRMED]: '',
    [QrStatus.SCANNED]: 'Ga verder in de Rabo Bankieren App',
    [QrStatus.TIMEOUT]: `<rds-notification type='warning' aria-live="assertive" header='De QR-code is verlopen'><a role="button" tabindex="0" onclick="document.querySelector('rass-sign').shadowRoot.getElementById('challenge-image').click()" class="rds-link rds-text-link--inline cursor-pointer">Vernieuw</a> de QR-code door er op te klikken.</rds-notification>`,
  },
  QR_HIGH_RISK_SIGNING:
    'Deze QR code kan je alleen gebruiken met een Rabobank App die met een identiteitsbewijs is geregistreerd.',
};

const enTranslations: RassQrTranslations = {
  errors: {
    timeout: {
      text: 'Error while reaching the server, please try again!',
      type: 'warning',
    },
    continue: 'Continue',
  },
  notifications: {
    [QrStatus.BLOCKED]: {
      text: 'QR code is not valid (anymore) or has been used on another device.',
      type: 'error',
    },
    [QrStatus.CANCELED]: {
      text: 'You have canceled your QR code.',
      type: 'info',
    },
    [QrStatus.REJECTED]: {
      text: 'You can not confirm using QR.',
      type: 'error',
    },
  },
  instructions: {
    [QrStatus.BLOCKED]: 'Click on the image to generate a new QR code',
    [QrStatus.CANCELED]: 'Click on the image to generate a new QR code',
    [QrStatus.ERROR]: 'Choose a different confirmation method',
    [QrStatus.ISSUED]: 'Scan the QR code using the Rabo App',
    [QrStatus.REJECTED]: 'Choose a different confirmation method',
    [QrStatus.CONFIRMED]: '',
    [QrStatus.SCANNED]: 'Proceed in the Rabo App',
    [QrStatus.TIMEOUT]: `<rds-notification type='warning' aria-live="assertive" header='The QR code has expired'><a role="button" tabindex="0" onclick="document.querySelector('rass-sign').shadowRoot.getElementById('challenge-image').click()"   class="rds-link rds-text-link--inline cursor-pointer">Refresh</a> the QR code by clicking on it.</rds-notification>`,
  },
  QR_HIGH_RISK_SIGNING:
    'This QR code can only be used with a Rabobank App that was registered with an identity document.',
};

export const rassQrTranslations = {
  [Language.NL]: nlTranslations,
  [Language.EN]: enTranslations,
  [Language.ES]: enTranslations,
  [Language.PT]: enTranslations,
};
